<script>
export default {
  name: "ButtonOfBrowseFileUploadComponent",
  emits: ["clickToShowModal"],
   props: {
      mini: {
         type: Boolean,
         default: false,
      },
      showSelection: {
         type: Boolean,
         default: true,
      },
   },
   methods: {
      clickModal(event) {
          this.$emit("clickToShowModal", event);
      }
  }
};
</script>
<template>
  <div v-if="showSelection" :class="{ 'img-thumbnail': !mini }">
    <!-- show big camera icon -->
    <button v-if="!mini" class="media-placeholder" @click="clickModal($event)">
      <div class="center-icon">
        <i class="icon fa fa-folder" /><br />
        <small class="label">
            {{ $t("visit-information-form.browse_file_picture_large_text") }}
        </small>
      </div>
    </button>

    <!-- else show small icon with text only when images has values -->
    <button v-else class="btn btn-primary btn-sm rounded-pill" @click="clickModal($event)">
      <span class="px-1">
        <i class="icon fa fa-folder mr-1" />
        {{ $t("visit-information-form.browse_file_picture_small_text") }}
      </span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
.media-placeholder {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  min-height: 200px;
  text-align: center;
  cursor: pointer;
  .center-icon {
    color: $secondary;
    opacity: 0.8;
    .icon {
      font-size: 2rem;
    }
  }
  &:hover {
    .center-icon {
      opacity: 1;
      .icon {
        color: $primary;
        transform: scale(1.15);
      }
    }
  }
}
</style>